/**
 * 设置localStorage存储的token
 * @param value
 * @param {string} cacheKey 存储名
 * @param {string} value
 */
export function setStorage (cacheKey, value) {
  return localStorage.setItem(cacheKey, value)
}

/**
 * 获取localStorage存储的token
 * @returns {string}
 * @param {string} key
 */
export function getStorage (key) {
  return localStorage.getItem(key)
}

/**
 * 删除localStorage存储的token
 * @param {string} key
 */
export function removeStorage (key) {
  return localStorage.removeItem(key)
}
